/**
 * Canary Console Messages
 * Displays welcome message and ASCII art in browser console
 */

document.addEventListener("DOMContentLoaded", function () {
    // Only show console messages for Canary (organisation ID: 1)
    if (!window.canaryApp || window.canaryApp.organisationId !== 1) {
        return;
    }

    // Wait a moment to ensure console is ready and page has loaded
    setTimeout(() => {
        // Clear console for a clean start (optional)
        // console.clear();

        // ASCII Art of "CANARY"
        const canaryAsciiArt = `
 ██████╗ █████╗ ███╗   ██╗ █████╗ ██████╗ ██╗   ██╗
██╔════╝██╔══██╗████╗  ██║██╔══██╗██╔══██╗╚██╗ ██╔╝
██║     ███████║██╔██╗ ██║███████║██████╔╝ ╚████╔╝ 
██║     ██╔══██║██║╚██╗██║██╔══██║██╔══██╗  ╚██╔╝  
╚██████╗██║  ██║██║ ╚████║██║  ██║██║  ██║   ██║   
 ╚═════╝╚═╝  ╚═╝╚═╝  ╚═══╝╚═╝  ╚═╝╚═╝  ╚═╝   ╚═╝   
        `;

        // Display the CANARY ASCII art
        console.log(
            "%c" + canaryAsciiArt,
            "color: #f59e0b; font-family: monospace; font-size: 10px; line-height: 1.1; font-weight: bold;"
        );

        // Main welcome message
        console.log(
            "%c👋 Hey Developer!",
            "color: #e11d48; font-size: 24px; font-weight: bold; text-shadow: 1px 1px 2px rgba(0,0,0,0.1);"
        );

        // About Canary message
        console.log(
            "%cCanary is built with the TALL stack and lots of ❤️ by a small team that is passionate about healthcare and patient wellbeing.",
            "color: #0ea5e9; font-size: 16px; line-height: 1.4; margin: 10px 0;"
        );

        // Call to action
        console.log(
            "%cInterested in being part of the journey? Reach out on our contact form.",
            "color: #10b981; font-size: 15px; font-weight: 500;"
        );

        // Bug reporting message
        console.log(
            "%cAnd of course, let us know of any errors or bugs you may find :)",
            "color: #f59e0b; font-size: 14px; font-style: italic;"
        );

        // Add some spacing
        console.log("\n");

        // Tech stack details (bonus!)
        console.log(
            "%cTech Stack:",
            "color: #6366f1; font-size: 14px; font-weight: bold;"
        );
        console.log(
            "%c• Tailwind CSS %c• Alpine.js %c• Laravel %c• Livewire",
            "color: #06b6d4; font-size: 12px;",
            "color: #10b981; font-size: 12px;",
            "color: #ef4444; font-size: 12px;",
            "color: #8b5cf6; font-size: 12px;"
        );
    }, 1500); // Delay to ensure page is fully loaded
});

// Optional: Detect when dev tools are opened for the first time
let devToolsMessageShown = false;

function detectDevTools() {
    // Only run for Canary (organisation ID: 1)
    if (!window.canaryApp || window.canaryApp.organisationId !== 1) {
        return;
    }

    const threshold = 160;

    if (
        (window.outerHeight - window.innerHeight > threshold ||
            window.outerWidth - window.innerWidth > threshold) &&
        !devToolsMessageShown
    ) {
        devToolsMessageShown = true;
        console.log(
            "%c🔍 Developer tools detected! Welcome to Canary's console 🐤",
            "background: linear-gradient(90deg, #667eea 0%, #764ba2 100%); color: white; padding: 8px 12px; border-radius: 4px; font-weight: bold;"
        );
    }
}

// Check for dev tools every 2 seconds
setInterval(detectDevTools, 2000);
